import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {ActivatedRouteSnapshot} from '@angular/router';
import {AuditTrailsService} from '../../../../../core/assignment';

@Injectable()
export class AuditTrailGetResolver implements Resolve<any> {
    constructor(public auditTrailsService: AuditTrailsService) {
    }

    resolve(route: ActivatedRouteSnapshot) {
        const itemId = Number(route.params.audit_id);
        return this.auditTrailsService.getById(itemId);
    }
}
